<template>
  <div>
    <el-card class="filter-card">
      <div class="filter-form">
        <div class="filter-form-left">
          <el-input
            v-model="queryParams.client_name"
            placeholder="用户标识"
            clearable
            style="width: 200px; margin-right: 10px;"
          />
          <el-select
            v-model="queryParams.is_active"
            placeholder="状态"
            clearable
            style="width: 120px; margin-right: 10px;"
          >
            <el-option label="启用" :value="true" />
            <el-option label="禁用" :value="false" />
          </el-select>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </div>
        <el-button type="primary" @click="openAddDialog">新增</el-button>
      </div>
    </el-card>

    <el-card class="table-card">
      <el-table
        v-loading="loading"
        :data="apiKeys"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="id" label="ID" width="60" />
        <el-table-column prop="client_name" label="用户标识" width="180" />
        <el-table-column prop="public_key" label="公钥" width="200">
          <template #default="{ row }">
            <div class="key-preview">
              <span>********************</span>
              <el-button
                size="small"
                link
                type="primary"
                @click="showKeyDialog('公钥', row.public_key)"
                style="margin-left: 8px;"
              >
                查看
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="private_key" label="私钥" width="200">
          <template #default="{ row }">
            <div class="key-preview">
              <span>********************</span>
              <el-button
                size="small"
                link
                type="primary"
                @click="showKeyDialog('私钥', row.private_key)"
                style="margin-left: 8px;"
              >
                查看
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="is_active" label="状态" width="90">
          <template #default="{ row }">
            <el-tag :type="row.is_active ? 'success' : 'danger'" size="small">
              {{ row.is_active ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="expire_at" label="过期时间" width="180" />
        <el-table-column prop="last_used_at" label="最后使用" width="180" />
        <el-table-column prop="created_at" label="创建时间" width="180"/>
        <el-table-column label="操作" width="200" fixed="right">
          <template #default="{ row }">
            <el-button size="small" @click="handleEdit(row)">编辑</el-button>
            <el-button
              size="small"
              :type="row.is_active ? 'warning' : 'success'"
              @click="handleToggleStatus(row)"
            >
              {{ row.is_active ? '禁用' : '启用' }}
            </el-button>
            <el-button size="small" style="color: #f56c6c" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

    <!-- 新增密钥弹窗 -->
    <el-dialog v-model="addDialogVisible" title="新增访问密钥" width="600px">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="用户标识" prop="client_name">
          <el-input v-model="form.client_name" placeholder="请输入用户标识" />
        </el-form-item>
        <el-form-item label="过期时间" prop="expire_at">
          <el-date-picker
            v-model="form.expire_at"
            type="datetime"
            placeholder="选择过期时间"
            style="width: 100%;"
            :disabled-date="disabledDate"
            value-format="YYYY-MM-DD HH:mm:ss"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="addDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitAdd">确定</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 编辑密钥弹窗 -->
    <el-dialog v-model="editDialogVisible" title="编辑访问密钥" width="600px">
      <el-form ref="editFormRef" :model="editForm" :rules="editRules" label-width="100px">
        <el-form-item label="用户标识" prop="client_name">
          <el-input v-model="editForm.client_name" placeholder="请输入用户标识" />
        </el-form-item>
        <el-form-item label="状态" prop="is_active">
          <div style="display: flex; align-items: center;">
            <el-switch v-model="editForm.is_active" />
            <span style="margin-left: 8px;">{{ editForm.is_active ? '启用' : '禁用' }}</span>
          </div>
        </el-form-item>
        <el-form-item label="过期时间" prop="expire_at">
          <el-date-picker
            v-model="editForm.expire_at"
            type="datetime"
            placeholder="选择过期时间"
            style="width: 100%;"
            :disabled-date="disabledDate"
            value-format="YYYY-MM-DD HH:mm:ss"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="editDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitEdit">确定</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 密钥详情弹窗 -->
    <el-dialog v-model="keyDialogVisible" title="密钥详情" width="600px">
      <div class="key-dialog-content">
        <div class="key-dialog-title">{{ keyDialogTitle }}</div>
        <el-input
          :model-value="currentKey"
          type="textarea"
          :rows="12"
          readonly
          class="key-textarea"
        />
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="keyDialogVisible = false">关闭</el-button>
          <el-button type="primary" @click="copyKey">复制</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { getApiKeys, createApiKey, updateApiKey, activateApiKey, deactivateApiKey, deleteApiKey } from '@/services/apikey'
import { ElMessage, ElMessageBox } from 'element-plus'
import { extractErrorMessage } from '@/utils/errorHandler'

export default {
  name: 'ApiKeyMgmt',
  setup() {
    const loading = ref(false)
    const apiKeys = ref([])
    const total = ref(0)
    const currentPage = ref(1)
    const pageSize = ref(20)
    const queryParams = ref({
      client_name: '',
      is_active: ''
    })

    const keyDialogVisible = ref(false)
    const keyDialogTitle = ref('')
    const currentKey = ref('')

    const addDialogVisible = ref(false)
    const formRef = ref(null)
    const form = ref({
      client_name: '',
      expire_at: ''
    })
    const rules = {
      client_name: [
        { required: true, message: '请输入用户标识', trigger: 'blur' }
      ],
      expire_at: [
        { required: true, message: '请选择过期时间', trigger: 'change' }
      ]
    }

    const editDialogVisible = ref(false)
    const editFormRef = ref(null)
    const currentEditId = ref(null)
    const editForm = ref({
      client_name: '',
      is_active: true,
      expire_at: ''
    })
    const editRules = {
      client_name: [
        { required: true, message: '请输入用户标识', trigger: 'blur' }
      ],
      expire_at: [
        { required: true, message: '请选择过期时间', trigger: 'change' }
      ]
    }

    // 禁用过去的日期
    const disabledDate = (time) => {
      return time.getTime() < Date.now() - 8.64e7
    }

    // 显示密钥详情弹窗
    const showKeyDialog = (title, key) => {
      keyDialogTitle.value = title
      currentKey.value = key
      keyDialogVisible.value = true
    }

    // 复制密钥到剪贴板
    const copyKey = () => {
      navigator.clipboard.writeText(currentKey.value).then(() => {
        ElMessage.success('复制成功')
      }).catch(() => {
        ElMessage.error('复制失败')
      })
    }

    const fetchApiKeys = async () => {
      loading.value = true
      try {
        const params = {
          skip: (currentPage.value - 1) * pageSize.value,
          limit: pageSize.value,
          ...queryParams.value
        }
        // 移除空字符串参数
        Object.keys(params).forEach(key => {
          if (params[key] === '') {
            delete params[key]
          }
        })
        
        const data = await getApiKeys(params)
        apiKeys.value = data.api_keys || []
        total.value = data.total || 0
      } catch (error) {
        console.error('获取访问密钥列表失败:', error)
        ElMessage.error(extractErrorMessage(error, '获取访问密钥列表失败'))
      } finally {
        loading.value = false
      }
    }

    const handleSizeChange = (size) => {
      pageSize.value = size
      currentPage.value = 1
      fetchApiKeys()
    }

    const handleCurrentChange = (page) => {
      currentPage.value = page
      fetchApiKeys()
    }

    const handleSearch = () => {
      currentPage.value = 1
      fetchApiKeys()
    }

    const resetSearch = () => {
      queryParams.value = {
        client_name: '',
        is_active: ''
      }
      currentPage.value = 1
      fetchApiKeys()
    }

    const openAddDialog = () => {
      addDialogVisible.value = true
      // 重置表单
      form.value = {
        client_name: '',
        expire_at: ''
      }
      if (formRef.value) {
        formRef.value.clearValidate()
      }
    }

    const submitAdd = async () => {
      if (!formRef.value) return
      try {
        await formRef.value.validate()
      } catch (error) {
        return
      }
      try {
        const data = {
          client_name: form.value.client_name,
          expire_at: form.value.expire_at
        }
        await createApiKey(data)
        ElMessage.success('访问密钥创建成功')
        addDialogVisible.value = false
        fetchApiKeys()
      } catch (error) {
        console.error('创建访问密钥失败:', error)
        ElMessage.error(extractErrorMessage(error))
      }
    }

    const openEditDialog = (row) => {
      editDialogVisible.value = true
      currentEditId.value = row.id

      // 用列表中的数据填充表单
      editForm.value = {
        client_name: row.client_name || '',
        is_active: row.is_active !== undefined ? row.is_active : true,
        expire_at: row.expire_at
      }

      // 清除表单验证状态
      if (editFormRef.value) {
        editFormRef.value.clearValidate()
      }
    }

    const submitEdit = async () => {
      if (!editFormRef.value) return
      try {
        await editFormRef.value.validate()
      } catch (error) {
        return
      }
      try {
        const data = {
          client_name: editForm.value.client_name,
          is_active: editForm.value.is_active,
          expire_at: editForm.value.expire_at
        }
        await updateApiKey(currentEditId.value, data)
        ElMessage.success('访问密钥更新成功')
        editDialogVisible.value = false
        fetchApiKeys()
      } catch (error) {
        console.error('更新访问密钥失败:', error)
        ElMessage.error(extractErrorMessage(error))
      }
    }

    const handleEdit = (row) => {
      openEditDialog(row)
    }

    const handleToggleStatus = async (row) => {
      const action = row.is_active ? '禁用' : '启用'
      const confirmMessage = `确认${action}密钥"${row.client_name}"吗？`
      
      ElMessageBox.confirm(
        confirmMessage,
        `${action}确认`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(async () => {
        try {
          if (row.is_active) {
            await deactivateApiKey(row.id)
            ElMessage.success('禁用成功')
          } else {
            await activateApiKey(row.id)
            ElMessage.success('启用成功')
          }
          fetchApiKeys()
        } catch (error) {
          console.error(`${action}访问密钥失败:`, error)
          ElMessage.error(extractErrorMessage(error))
        }
      }).catch(() => {
        // 用户取消
      })
    }

    const handleDelete = (row) => {
      ElMessageBox.confirm(
        `确认删除密钥"${row.client_name}"吗？此操作不可恢复。`,
        '删除确认',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(async () => {
        try {
          await deleteApiKey(row.id)
          ElMessage.success('删除成功')
          fetchApiKeys()
        } catch (error) {
          console.error('删除访问密钥失败:', error)
          ElMessage.error(extractErrorMessage(error))
        }
      }).catch(() => {
        // 用户取消删除
      })
    }

    onMounted(() => {
      fetchApiKeys()
    })

    return {
      loading,
      apiKeys,
      total,
      currentPage,
      pageSize,
      queryParams,
      addDialogVisible,
      form,
      rules,
      formRef,
      editDialogVisible,
      editForm,
      editRules,
      editFormRef,
      handleSizeChange,
      handleCurrentChange,
      handleSearch,
      resetSearch,
      openAddDialog,
      submitAdd,
      openEditDialog,
      submitEdit,
      handleEdit,
      handleToggleStatus,
      handleDelete,
      disabledDate,
      showKeyDialog,
      keyDialogVisible,
      keyDialogTitle,
      currentKey,
      copyKey
    }
  }
}
</script>

<style scoped>
.header {
  margin-bottom: 10px;
}
.header h2 {
  margin: 0 0 8px 0;
  font-size: 24px;
  color: #303133;
}
.header p {
  margin: 0;
  color: #909399;
  font-size: 14px;
}
.filter-card {
  margin-bottom: 10px;
}
.filter-form {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.filter-form-left {
  display: flex;
  align-items: center;
}
.table-card {
  margin-bottom: 10px;
}
.key-preview {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  display: flex;
  align-items: center;
}
.pagination {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.key-dialog-content {
  padding: 10px 0;
}
.key-dialog-title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #303133;
}
.key-textarea {
  font-family: 'Courier New', Courier, monospace;
  font-size: 12px;
}
</style>
